<app-login-page>
  <div class="form-container">
    <div *ngIf="errorMessage">
      <app-message severity="error" [noMargin]="true" data-cy="send-error-message">
        {{ errorMessage }}
      </app-message>
    </div>
    <div *ngIf="successMessage">
      <app-message severity="success" [noMargin]="true" data-cy="send-success-message">
        {{ successMessage }}
      </app-message>
    </div>

    <div *ngIf="!isSent">
      <h1 class="text-primary-blue-700">Sign Up</h1>
      <form [formGroup]="signUpForm" (ngSubmit)="sendActivation()" formId="signUpForm" data-cy="sign-up-form">
        <app-form-field
          [control]="asFormControl(signUpForm.get('email'))"
          name="email"
          label="Email"
          type="input"
        ></app-form-field>
        <app-form-footer
          [disabled]="disableButton"
          submitLabel="Submit"
          [noCancel]="true"
          [fullWidthButtons]="true"
        ></app-form-footer>
        <p class="inline-link">
          Already have an account? <a class="inner-link no-underline" [routerLink]="['/login']">Sign In</a>
        </p>
      </form>
    </div>
    <div *ngIf="isSent">
      <h1 class="text-primary-blue-700">You're almost there!</h1>
      <p>If a matching email address is found, you will receive an email with an activation link.</p>
      <p>If not, please call CCS @ {{ helpPhone }} for additional help.</p>
      <button
        pButton
        class="w-full"
        label="Resend Activation Email"
        (click)="sendActivation()"
        [disabled]="disableButton"
      ></button>
      <p class="inline-link">
        Already have an account? <a class="inner-link no-underline" [routerLink]="['/login']">Sign In</a>
      </p>
    </div>
    <app-mobile-footer></app-mobile-footer>
  </div>
</app-login-page>
